module.exports = __webpack_public_path__ + "media/images/work_phone-4ea984e427722d81ad0b066b78b83392.svg";